import axios from 'axios';

export const getDeviceChannel = (that, deviceId) => {
  return axios({
    url: `/api/devices/${deviceId}/channels`,
    method: 'get',
    params: {
      token: that.$cookies.get("session").token,
    }
  })
}
export const deviceList = (page, count) => {
  return axios({
    method: 'get',
    url:`/api/devices/query`,
    params: {
      page,
      count
    }
  })
}

export const postStartPlay = (deviceId, channelId, token) => {
  console.log("通知设备推流1: " + deviceId + " : " + channelId);

  return axios({
    url: '/api/play/start/' + deviceId + '/' + channelId,
    params: {
      token: this.$cookies.get("session").token,
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/deviceApi.js